import React from 'react';
import styled from 'styled-components';
import media from 'styled-media-query';
import ogpImage from '../../images/default.png';
import { EexternalLinkedList } from './external';
import Footer from './footer';
import { GlobalStyle } from './globalStyle';
import { InternalLinkedList } from './internal';
import Logo from './logo';
import Meta from './meta';

const Grid = styled.div`
  display: grid;
  gap: 1rem;
  margin: 1rem;
  grid-template:
    'logo external .  internal' 5rem
    'content content content content' minmax(calc(100vh - 11rem), auto)
    'footer footer footer footer' 2rem / auto auto 1fr auto;
  ${media.lessThan('large')`
    grid-template:
    'logo logo' 4rem
    'external internal' auto
    'content content' minmax(calc(100vh - 8rem), auto)
    'footer footer' 2rem / 1fr 1fr;
  `}
  ${media.lessThan('medium')`
    grid-template:
    'logo' 4rem
    'external' auto
    "internal" auto
    'content' auto
    'footer' 2rem / auto;
    margin: 0;
  `}
`;

const Content = styled.div`
  grid-area: content;
`;

type Props = {
  children: React.ReactNode;
  type: Page;
  siteMetadata: GatsbyTypes.SiteSiteMetadata;
  title?: string;
  desc?: string;
  image?: string;
};

const Layout: React.VFC<Props> = ({
  children,
  type,
  title: titleUnsafe,
  desc: descUnsafe,
  image = ogpImage,
  siteMetadata,
}: Props) => {
  const title = titleUnsafe
    ? `${titleUnsafe} | ${siteMetadata.title}`
    : `${siteMetadata.title}`;
  const desc = descUnsafe || siteMetadata.description;

  return (
    <Grid>
      <Meta
        title={title}
        desc={desc}
        image={image}
        type={type}
        siteMetadata={siteMetadata}
      />
      <GlobalStyle />
      <Logo type={type} />
      <EexternalLinkedList />
      <InternalLinkedList type={type} />
      <Content>{children}</Content>
      <Footer />
    </Grid>
  );
};

export default Layout;
